shvenergy.somesharebuttons = (function ($) {
    "use strict";

    // Social Media share buttons
    function init() {
        var inclusiveSoMeButtons = document.querySelectorAll("[data-inclusive-menu-opens]");
        let soMeShareList = document.querySelectorAll(".so-me-share__list li");
        let soMeSharePopUp = document.querySelectorAll(".so-me-share__popup a");
        let ogDescription = document.querySelector("[property='og:description']") ? document.querySelector("[property='og:description']").content : "";
        let ogImage = document.querySelector("[property='og:image']") ? document.querySelector("[property='og:image']").content : "";

        inclusiveSoMeButtons.forEach(function (SoMeButton) {

            if (SoMeButton) {
                new MenuButton(SoMeButton);
            }

        });
        soMeShareList.forEach(function (soMeShareLink) {
            if (soMeShareLink && soMeShareLink.children[0].href && soMeShareLink.children[0].href.includes("www.pinterest.com")) {
                let url = soMeShareLink.children[0].href;
                let mediaPos = url.search("&media=");
                let descriptionPost = url.search("&description=");
                let isDescriptionEmpty = url.split("&description=").splice(-1);

                if (isDescriptionEmpty == '') {
                    if (ogDescription) {
                        url = url.replace(url.substring(descriptionPost), "&description=" + encodeURIComponent(ogDescription));
                    } else {                       
                        soMeShareLink.style.display = 'none'
                    }
                }
                if (ogImage) {
                    url = url.replace(url.substring(mediaPos, descriptionPost), "&media=" + encodeURIComponent(ogImage));
                } else {                   
                    soMeShareLink.style.display = 'none'
                }
                soMeShareLink.children[0].href = url;
            }
        })

        soMeSharePopUp.forEach(function (soMeSharePopLink) {
            if (soMeSharePopLink && soMeSharePopLink.href && soMeSharePopLink.href.includes("www.pinterest.com")) {
                var url = soMeSharePopLink.href;
                var mediaPos = url.search("&media=");
                var descriptionPost = url.search("&description=");
                var isDescriptionEmpty = url.split("&description=").splice(-1);

                if (isDescriptionEmpty == '') {
                    if (ogDescription) {
                        url = url.replace(url.substring(descriptionPost), "&description=" + encodeURIComponent(ogDescription));
                    } else {
                        soMeSharePopLink.style.display = 'none';
                    }
                }
                if (ogImage) {
                    url = url.replace(url.substring(mediaPos, descriptionPost), "&media=" + encodeURIComponent(ogImage));
                } else {
                    soMeSharePopLink.style.display = 'none';
                }
                soMeSharePopLink.href = url;
            }
        });

        $('ul.so-me-share__list a').on("click", (el) => {
            trackArticleShareClick(el);
        });

        $('ul.so-me-share__list a').on("auxclick", (el) => {
            trackArticleShareClick(el);
        });

        function trackArticleShareClick(el) {
            let soMeButton = $(el.target).closest("a")[0],
                name = soMeButton.dataset.socialPlatform.trim();

            shvenergy.tracking.trackRawEventData({
                'event': 'clickArticleShare',
                'socialName': name
            });
        }

    }

    init();

})(jQuery);